import { useRouter } from "next/router";

export default function useRtl(): boolean {
  const { locale } = useRouter();
  return locale?.substring(0, 2) == "ar";
}
